module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_2_m2.0ece45ea4a840cbc76e0fe2c4b71f5ec.png";